import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteFootprintingPigletByPrimaryDataId, deleteFootprintingPigletByPrimaryDataIdAdmin } from "services";

import { footprintingPigletPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import {
  FOOTPRINTING_CROP_PRIMARY_DATA,
  FOOTPRINTING_PIGLET_HERD_DETAILS,
  FOOTPRINTING_PIGLET_MANURE_ADDITIVE,
  FOOTPRINTING_PIGLET_MANURE_STORAGE,
} from "consts";

export const useDeleteFootprintingPigletByPrimaryDataId = (farmId: string, year: number, primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [FOOTPRINTING_CROP_PRIMARY_DATA],
    mutationFn: () => {
      if (!primaryDataId) return Promise.resolve(null);
      return isAdmin ? deleteFootprintingPigletByPrimaryDataIdAdmin(primaryDataId) : deleteFootprintingPigletByPrimaryDataId(primaryDataId);
    },
    onSuccess: async () => {
      invalidateAndRefecthQueries(queryClient, [
        // All the extra keys clean up the mess of stuff from this now-deleted data
        [FOOTPRINTING_PIGLET_HERD_DETAILS, primaryDataId, isAdmin],
        [FOOTPRINTING_PIGLET_MANURE_ADDITIVE, primaryDataId, isAdmin],
        [FOOTPRINTING_PIGLET_MANURE_STORAGE, primaryDataId, isAdmin],
        ...footprintingPigletPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
      ]);
    },
  });
};
